import ErrorHandler from '@/ErrorHandler';
import GlobalEventBus from '@/GlobalEventBus';
import GlobalEvents from '@/GlobalEvents';
import API from '@/org-app/api';
import { createGetAllAction, createGetOneAction, createPostAction, createPutAction } from '@/utils/ActionsUtils';
import i18n from '@/vueI18n';

import * as types from './mutation-types';

const actions = {
  getNetworks: createGetAllAction(
    API.instance.getNetworks,
    types.UPDATE_NETWORKS_LIST,
    'messages.failedToGetNetworks',
    false,
  ),
  async getNetworksForPublicPlan({ commit }, params) {
    const { cancelTokenSource, showLoader, planUuid, queryParams } = params;
    if (showLoader) {
      GlobalEventBus.$emit(GlobalEvents.loading);
    }

    try {
      return await API.instance.getNetworksForPublicPlan({
        password: queryParams,
        cancelTokenSource,
        showLoader,
        planUuid,
      });
    } catch (error) {
      if (error != null) {
        const msg = i18n.global.t('messages.failedToGetNetworks');
        ErrorHandler.showError(msg, error);
        throw error;
      }
    } finally {
      if (showLoader) {
        GlobalEventBus.$emit(GlobalEvents.loaded);
      }
    }
    return null;
  },
  getNetwork: createGetOneAction(API.instance.getNetwork, types.UPDATE_NETWORK, 'messages.failedToGetNetworks', true),
  createNetwork: createPostAction(API.instance.postNetwork, types.SAVE_NETWORK, 'messages.failedToCreateNetwork'),
  updateNetwork: createPutAction(API.instance.putNetwork, types.UPDATE_NETWORK, 'messages.failedToUpdateNetwork'),
};

export default actions;
